import { Config } from "atoms/Rtool/newConfigAtoms";
import { DRIVE_MODE_IDS, PHENOMENON_IDS } from "utils/consts";
import { DRIVE_MODE_IDS as HEV_DRIVE_MODE_IDS, PHENOMENON_IDS as HEV_PHENOMENON_IDS } from "utils/constsHev";

export const isInitial = (c: Config) =>
    Object.values(c).every(v => v === "");

export function removeDuplicates<T>(arr: T[]): T[] {
    return arr.filter((item, idx, self) =>
        self.indexOf(item) === idx
    );
};

// HEV では aco を含まない HEV 固有 condition 値域（gn/vib 系 phenomenon × HEV drive_mode）を使う。
export function buildConditionIds(isHev = false): string[] {
    const phenSrc: readonly string[] = isHev ? HEV_PHENOMENON_IDS : PHENOMENON_IDS;
    const drvSrc: readonly string[] = isHev ? HEV_DRIVE_MODE_IDS : DRIVE_MODE_IDS;
    const phen = phenSrc.filter((p) => p !== null);
    const drv = drvSrc.filter((d) => d !== null);
    return phen.flatMap((p) => drv.map((d) => `${p}-${d}`));
};
